var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.2794V27.3327C4.5 27.706 4.79333 27.9994 5.16667 27.9994H9.22C9.39333 27.9994 9.56667 27.9327 9.68667 27.7994L24.2467 13.2527L19.2467 8.25269L4.7 22.7994C4.56667 22.9327 4.5 23.0927 4.5 23.2794ZM28.1133 9.38602C28.2369 9.26267 28.335 9.11615 28.4019 8.95485C28.4688 8.79355 28.5033 8.62064 28.5033 8.44602C28.5033 8.27139 28.4688 8.09848 28.4019 7.93719C28.335 7.77589 28.2369 7.62937 28.1133 7.50602L24.9933 4.38602C24.87 4.26241 24.7235 4.16435 24.5622 4.09744C24.4009 4.03053 24.228 3.99609 24.0533 3.99609C23.8787 3.99609 23.7058 4.03053 23.5445 4.09744C23.3832 4.16435 23.2367 4.26241 23.1133 4.38602L20.6733 6.82602L25.6733 11.826L28.1133 9.38602Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.30c992d40228613be68922c03d49a2f4.svg";
export { ForwardRef as ReactComponent };